import { type IDialogCloseButtonProperties } from "./DialogCloseButton.types";

export const getAnalyticsAttributes = (
  eventType: IDialogCloseButtonProperties["analyticsEventType"],
  properties: IDialogCloseButtonProperties["analyticsProperties"] = {},
): Record<string, string | boolean> => {
  if (eventType == null) {
    return {};
  }

  return {
    "data-amp-default-track": true,
    "data-amp-event-type": eventType,
    ...Object.fromEntries(Object.entries(properties).map(([key, value]) => [`data-amp-${key}`, value])),
  };
};
